import React from 'react'
import styles from '../../styles/common/Checkbox.module.scss'

interface QuizCheckboxProps {
  checked?: boolean
  disabled?: boolean
  onChange?: (checked: boolean) => void
  className?: string
  children?: React.ReactNode
}

const QuizCheckbox: React.FC<QuizCheckboxProps> = ({
  checked = false,
  disabled = false,
  onChange,
  className = '',
  children,
}) => {
  return (
    <label className={`${styles.checkboxContainer} ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
        className={styles.checkbox}
        disabled={disabled}
      />
      {children && <span className={styles.checkboxLabel}>{children}</span>}
    </label>
  )
}

export default QuizCheckbox
